<wchfs-checkbox
  #checkbox
  class="collective-checkbox"
  color="primary"
  [checked]="isCurrentPageFullySelected"
  [indeterminate]="isCurrentPagePartiallySelected"
  (change)="toggleCurrentPageSelection(checkbox)"
  [dataCy]="'collective-selection-checkbox'"
></wchfs-checkbox>
